// Instancia central de Day.js para toda la app (reemplazo de moment).
// Configura una sola vez los plugins y los locales disponibles; todos los
// módulos deben importar dayjs DESDE AQUÍ para heredar plugins y locales.
//
// El locale ACTIVO ya no se fija acá: lo decide el Formato Regional del
// proyecto vía applyProjectLocale() (utils/localeBootstrap.js). Este archivo
// sólo registra los locales soportados ('es' y 'en') y deja puesto el default
// del sistema para el instante entre el arranque del bundle y la lectura del
// token. Antes tenía `dayjs.locale('es')` fijo, lo que hacía imposible que un
// proyecto en en-US mostrara nombres de mes/día en inglés.
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import isoWeek from 'dayjs/plugin/isoWeek'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import 'dayjs/locale/es'
import 'dayjs/locale/en'
import { DEFAULT_LOCALE, dayjsLocaleFor } from './localeConfig'

dayjs.extend(utc)               // dayjs.utc(...)
dayjs.extend(timezone)          // dayjs.tz(...) — requiere utc, va después
                                // Habilita expresar la hora DEL PROYECTO con
                                // reglas IANA, o sea con horario de verano
                                // resuelto solo. Viene dentro del paquete
                                // dayjs: no agrega dependencias.
dayjs.extend(customParseFormat) // dayjs(str, ['HH:mm:ss','HH:mm'])
dayjs.extend(isoWeek)           // startOf('isoWeek'), isoWeekday()
dayjs.extend(isSameOrBefore)    // isSameOrBefore(...)

dayjs.locale(dayjsLocaleFor(DEFAULT_LOCALE))

export default dayjs
